export default __webpack_public_path__ + "static/media/twitter.f6d5d420.svg";